module.exports = __webpack_public_path__ + "img/header-m.beb4a364.jpg";